import { useState } from 'react';
import OrderStatusBadge from './OrderStatusBadge';

const OrderStatusDropdown = ({ currentStatus, statusKey, statusLabel, onStatusChange, orderId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const statuses = [
    { value: 'pending', label: 'Pending' },
    { value: 'packed', label: 'Packed' },
    { value: 'shipped', label: 'Shipped' },
    { value: 'returned', label: 'Returned' },
    { value: 'canceled', label: 'Canceled' },
  ];

  const handleStatusChange = (newStatus) => {
    onStatusChange(orderId, newStatus);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button
        className="btn btn-small"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-2)' }}
      >
        <OrderStatusBadge status={currentStatus} statusKey={statusKey} statusLabel={statusLabel} />
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
      
      {isOpen && (
        <>
          <div
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 1,
            }}
            onClick={() => setIsOpen(false)}
          />
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              marginTop: 'var(--sp-2)',
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--r-md)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              zIndex: 2,
              minWidth: '150px',
            }}
          >
            {statuses.map((status) => (
              <button
                key={status.value}
                onClick={(e) => {
                  e.stopPropagation();
                  handleStatusChange(status.value);
                }}
                style={{
                  width: '100%',
                  padding: 'var(--sp-3)',
                  textAlign: 'left',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: 'var(--fs-sm)',
                }}
                onMouseEnter={(e) => (e.target.style.background = 'var(--neutral-100)')}
                onMouseLeave={(e) => (e.target.style.background = 'transparent')}
              >
                {status.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default OrderStatusDropdown;
